import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

import { MIQAAT_VENUE_MAPS_INCLUDED_REGION_CODES } from "./miqaat-venue-location";

let configuredKey: string | null = null;

/**
 * Configures and loads Maps JS + Places (New) libraries once per page.
 * Call only when `VITE_GOOGLE_MAPS_API_KEY` is present.
 */
export async function loadGoogleMapsForVenuePicker(apiKey: string): Promise<{
  Map: typeof google.maps.Map;
  Marker: typeof google.maps.Marker;
  Circle: typeof google.maps.Circle;
  AutocompleteSuggestion: typeof google.maps.places.AutocompleteSuggestion;
  AutocompleteSessionToken: typeof google.maps.places.AutocompleteSessionToken;
}> {
  if (configuredKey !== apiKey) {
    setOptions({
      key: apiKey,
      v: "weekly",
      region: MIQAAT_VENUE_MAPS_INCLUDED_REGION_CODES[0].toUpperCase(),
      language: "en",
    });
    configuredKey = apiKey;
  }

  const [{ Map }, placesLib] = await Promise.all([importLibrary("maps"), importLibrary("places")]);

  const { AutocompleteSuggestion, AutocompleteSessionToken } = placesLib;
  if (!AutocompleteSuggestion || !AutocompleteSessionToken) {
    throw new Error(
      "Places AutocompleteSuggestion is unavailable. Enable Places API (New) and Maps JavaScript API."
    );
  }

  // Classic Marker / Circle ship with the Maps JS API after `maps` is loaded.
  return {
    Map,
    Marker: google.maps.Marker,
    Circle: google.maps.Circle,
    AutocompleteSuggestion,
    AutocompleteSessionToken,
  };
}
